// Packages
import DayPicker, { DateUtils } from "react-day-picker";
import { useDispatch, useSelector } from "react-redux";
import MomentLocaleUtils from "react-day-picker/moment";
import { useTranslation } from "react-i18next";
import { setFieldShipping } from "../../actions/checkoutStore";
import { useEffect, useRef, useState } from "react";

import "react-day-picker/lib/style.css";

const WEEK_DAY_ENUM = Object.freeze({
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
});

function DateOnlyField({ shippingMethod }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dateOpen, setDateOpen] = useState(false);
  const containerRef = useRef(null);

  function isTimeAfter(compareHour, compareMinute) {
    const pad = (n) => String(n).padStart(2, "0");

    const now = new Date();
    const currentTimeStr = now.toTimeString().slice(0, 8);
    const compareTimeStr = `${pad(compareHour)}:${pad(compareMinute)}:00`;

    return currentTimeStr > compareTimeStr;
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setDateOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const checkWeek = (date, weekday) => {
    if (date.getDay() != WEEK_DAY_ENUM[weekday.weekday]) return false;
    if (new Date().toDateString() != date.toDateString()) return false;
    return isTimeAfter(weekday.hours, weekday.minutes);
  };

  const checkOrder = (date, order) => {
    let today = new Date();
    today.setDate(today.getDate() + order.days);
    if (date.toDateString() != today.toDateString()) return false;
    return isTimeAfter(order.hours, order.minutes);
  };

  const checkDate = (date, schedule_date) => {
    if (date.toDateString() != new Date(schedule_date.date).toDateString())
      return false;
    return true;
  };

  const handleDisabledDays = (day) => {
    if (DateUtils.isPastDay(day)) {
      return true;
    }
    var available = false;
    shippingMethod.order_schedule.scheduling_values_weekly.forEach(
      (weekday) => {
        if (checkWeek(day, weekday)) {
          available = true;
        }
      },
    );
    shippingMethod.order_schedule.scheduling_values_order.forEach((order) => {
      if (checkOrder(day, order)) {
        available = true;
      }
    });
    shippingMethod.order_schedule.scheduling_values_date.forEach(
      (schedule_date) => {
        if (checkDate(day, schedule_date)) {
          available = true;
        }
      },
    );
    return available;
  };

  return (
    <div className="row m-2">
      <div className="form-group">
        <div
          className={"input-placeholder floating-label-wrap position-relative"}
        >
          <div className="floating-label-wrap">
            <label htmlFor={"shipping_date"} className="label-checkout">
              {t("information.order_scheduling")}
            </label>
            <input
              type="text"
              className="floating-label-field floating-label-field--s1"
              id="shipping_date"
              onChange={() => {}}
              onClick={() => {
                setDateOpen(true);
              }}
              value={state.checkoutStore.shipping.date}
            />
          </div>
          {dateOpen && (
            <div
              className="dropdown-menu row px-0 m-0 day-picker-dropdown d-block"
              ref={containerRef}
            >
              <DayPicker
                className="row px-0 mx-0 w-100 Range"
                onDayClick={(date, { disabled }) => {
                  if (disabled) return;
                  setDateOpen(false);
                  dispatch(
                    setFieldShipping("date", date.toISOString().split("T")[0]),
                  );
                }}
                disabledDays={handleDisabledDays}
                selectedDays={state.checkoutStore.shipping.date}
                localeUtils={MomentLocaleUtils}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DateOnlyField;
